import { useState, useContext } from 'react';
import { Button, InputGroup, Form } from 'react-bootstrap';
import { ReactComponent as EyeSlashicon } from '../../src/assets/images/eye-slash.svg'
import { ReactComponent as Eyeicon } from '../../src/assets/images/eye.svg'
import { FormErrorContext } from './FormErrorContext';
import { MessagesContext } from 'messages/MessagesContext';
import _ from "lodash";

export const PasswordField = (props) => {

    const { formErrors } = useContext(FormErrorContext);
    const { messages } = useContext(MessagesContext);

    let fieldError = undefined;
    let valstate = props.valstate;
    if (!_.isEmpty(formErrors)) {
        fieldError = formErrors[props.name];
        valstate = false;
    }

    const [passwordType, setPasswordType] = useState('password');
    const togglePasswordType = () => {
        if (passwordType === 'password') {
            setPasswordType('text');
        } else {
            setPasswordType('password');
        }
    }

    return (<Form.Group controlId={props.name}>
        <Form.Label>{props.label}</Form.Label>
        <InputGroup>
            <Form.Control
                name={props.name}
                type={passwordType}
                placeholder={props.placeholder}
                value={props.value || ""}
                style={{ backgroundColor: props.valstate ? "" : "pink" }}
                onChange={props.onChange}
                onBlur={props.onBlur}
                onKeyDown={props.onKeyDown}
                isInvalid={!props.valstate}
                readOnly={props.readOnly}
                ref={props.rref}
                className={props.className}
            />
            <Button variant="light" className="pt-0 pb-0" onClick={togglePasswordType} >
                {passwordType === 'password' ? <Eyeicon /> : <EyeSlashicon />}
            </Button>
            {!props.valstate && (<Form.Control.Feedback type="invalid">{props.valMsg}</Form.Control.Feedback>)}
            {fieldError && (<Form.Control.Feedback type="invalid">{fieldError}:{messages[fieldError]}</Form.Control.Feedback>)}
        </InputGroup>
    </Form.Group>

    )
}